import { Flex } from '@chakra-ui/react'
import React, { useEffect, useRef, useState } from 'react'
import { getQueue } from '../../classes/Queue'
import { useUserContext } from '../../context/userContext'
import { AlertError } from '../shared'
import QueueInfo from './QueueInfo'

const QueueInfoPreview = ({ id }) => {
    const [loadDataError, setLoadDataError] = useState(null)
    const [queueData, setQueueData] = useState(null)
    const {userData } = useUserContext()
    const loadData = useRef()
    loadData.current = async () => {
        await getQueue(id, userData.token)
            .then(res => {
                setQueueData(res)
            })
            .catch(error => {
                // console.log('error')
                setLoadDataError(error)
            })
    }

    useEffect(() => {
        loadData.current()
    }, [])

    return (
        <Flex w="full">
            {loadDataError && <AlertError error={loadDataError} />}
            {queueData && <QueueInfo data={queueData} />}
        </Flex>
    )
}

export default QueueInfoPreview
